/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        stepper: {
            paddingTop: {
                value: "12px",
                type: "dimension",
            },
            paddingBottom: {
                value: "12px",
                type: "dimension",
            },
            gap: {
                value: "12px",
                type: "dimension",
            },
            step: {
                gap: {
                    value: "12px",
                    type: "dimension",
                },
                icon: {
                    width: {
                        value: "32px",
                        type: "dimension",
                    },
                    height: {
                        value: "32px",
                        type: "dimension",
                    },
                    default: {
                        backgroundColor: {
                            value: "#f3f3f3",
                            type: "color",
                        },
                        color: {
                            value: "#282e37",
                            type: "color",
                        },
                    },
                    active: {
                        backgroundColor: {
                            value: "#121a26",
                            type: "color",
                        },
                        color: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                    completed: {
                        backgroundColor: {
                            value: "#d2ff9c",
                            type: "color",
                        },
                        color: {
                            value: "#464e53",
                            type: "color",
                        },
                    },
                    text: {
                        fontSize: {
                            value: "0.875rem",
                            type: "dimension",
                        },
                        lineHeight: {
                            value: "1.25rem",
                            type: "dimension",
                        },
                        letterSpacing: {
                            value: "0.2px",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 600,
                            type: "number",
                        },
                        default: {
                            color: {
                                value: "#282e37",
                                type: "color",
                            },
                        },
                        active: {
                            color: {
                                value: "#ffffff",
                                type: "color",
                            },
                        },
                    },
                },
                label: {
                    fontSize: {
                        value: "0.875rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.25rem",
                        type: "dimension",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    active: {
                        fontWeight: {
                            value: 600,
                            type: "number",
                        },
                    },
                },
            },
            connector: {
                color: {
                    value: "#dadada",
                    type: "color",
                },
                width: {
                    value: "24px",
                    type: "dimension",
                },
                height: {
                    value: "1px",
                    type: "dimension",
                },
            },
        },
    },
};
export default tokens;
